var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.albumid || _vm.byDate || _vm.byCategory
        ? _c("CloudPhotoSelectorView", {
            staticClass: "cloudPhotoSelector",
            attrs: {
              "channel-model": _vm.channelModel,
              albumid: _vm.albumid,
              "by-category": _vm.byCategory,
              "import-mode": _vm.importMode,
            },
            on: {
              browseByAlbum: _vm.browseByAlbum,
              browseByCategory: _vm.browseByCategory,
              browseByDate: _vm.browseByDate,
              levelUp: _vm.levelUp,
              selectPhoto: _vm.selectPhoto,
            },
          })
        : _c("div", { staticClass: "contentBlock" }, [
            _c("div", { staticClass: "workSpaceWrapper" }, [
              _c("div", { staticClass: "workSpace" }, [
                _c("div", { staticClass: "viewHeader" }, [
                  _c("div", { attrs: { id: "cloudalbum_userswitch" } }),
                  _vm._v(" "),
                  _c("span", { staticClass: "header" }, [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("cloudAlbumSelectorDescription")) +
                        "\n\t\t\t\t\t"
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { attrs: { id: "albumsRegion" } }, [
                  _vm.albums.collection.length > 0 && _vm.albums.fetched
                    ? _c(
                        "ul",
                        { staticClass: "albumGrid" },
                        _vm._l(_vm.albums.collection, function (albumModel) {
                          return _c("CloudAlbumView", {
                            key: albumModel.id,
                            attrs: { "album-model": albumModel },
                            on: { selectAlbum: _vm.selectAlbum },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "workSpaceFooter" }, [
                _vm.loading
                  ? _c("div", { staticClass: "loading" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("loading")) +
                          "\n\t\t\t\t\t"
                      ),
                      _c("br"),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "loadingBar" }),
                    ])
                  : _vm.albums.nextPage || _vm.albums.nextOptions
                  ? _c(
                      "button",
                      {
                        staticClass: "toolbutton",
                        on: { click: _vm.loadMore },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(_vm.$t("buttonLoadMore")) +
                            "\n\t\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }